module.exports = __webpack_public_path__ + "fonts/OpenSans-ExtraBoldItalic.d69a7487.woff2";